<template>
  <header id="blankHeader" class="text-3xl pr-4 py-4 tablet:pl-20 laptop:pl-4">
    <div class="flex justify-between">
      <BlankHeaderContent />
    </div>
  </header>
</template>

<script setup lang="ts">
import BlankHeaderContent from '../content/BlankHeaderContent.vue';
</script>
